import * as React from 'react';
import Styled, { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';

import { SvgContainer } from './Common/SVGContainer';

export const HeaderProgressStepContainer = Styled.div`
  order: 2;
  display: flex;
  justify-content: space-between;
  vertical-align: text-bottom;
  padding: 1em;
  border-top: 1px solid ${props => props.theme.colorSlate5};

  ${media.medium`
    flex: 1;

    /* override mobile */
    padding: 0;
    display: block;
    border: none;
  `}
`;

export const HeaderProgressSteps = Styled.ul`
  ${media.medium`
    display: flex;
    padding-right: 5%;
  `}

  ${media.large`
    padding-right: 15%;
  `}
`;

HeaderProgressSteps.displayName = 'HeaderProgressSteps';

export interface IHeaderProgressStepProps {
  active?: boolean;
  /**
   * whether or not this is the step before the active one
   */
  previous?: boolean;
}

const subnavArrowWidth: number = 15;

const HProgressStep = Styled.li<IHeaderProgressStepProps>`
  display: none;
  font-weight: 700;
  position: relative;
  font-size: 1.4rem;

  ${props => props.active && `
    display: inline-block;
  `}

  ${props => props.previous && `
    display: inline-block;
    color: ${props.theme.text.colorText};
  `}

  ${props => css`
    ${media.medium`
      flex: 1 1 auto;
      align-items: center;
      padding: 1.75em 0;
      display: inline-block;
      position: relative;
      text-align: center;
      line-height: 1.3;
      color: ${props.theme.colorSlate50};
      padding-left: ${subnavArrowWidth}px;
      padding-right: ${subnavArrowWidth}px;

      &:not(:last-child) {
        padding-right: 0;
      }

      &:first-child {
        padding-left: ${subnavArrowWidth}px;
      }

      &:last-child {
        &::before,
        &::after {
          display: none;
        }
      }

      &::before,
      &::after {
        width: 0;
        height: 0;
        content: '';
        border-top: 34px solid transparent;
        border-bottom: 34px solid transparent;
        display: block;
        position: absolute;
        top: 0;
      }

      &::before {
        border-left: ${subnavArrowWidth}px solid ${props.theme.colorSlate50};

        /* push bottom arrow out 1px to reveal "border" */
        left: calc(100% + 1px);
        z-index: 111;
      }

      &::after {
        border-left: ${subnavArrowWidth}px solid ${props.theme.colorWhite};
        left: 100%;
        z-index: 222;
      }

      ${props.active ? `
        color: ${props.theme.text.colorText};
      ` : `
        background: ${props.theme.colorSlate5};
        color: ${props.theme.colorSlate70};

        &::after {
          border-left: ${subnavArrowWidth}px solid ${props.theme.colorSlate5};
        }
      `}
    `}
  `}
`;
// tslint:enable

HProgressStep.defaultProps = {
  previous: false
};

const SvgContainerWrapper = Styled(SvgContainer)`
  vertical-align: bottom;
  top: 0.125em;
  position: relative;

  ${media.medium`
      display: none;
  `}
`;

export const HeaderProgressStep: React.FunctionComponent = props => (
  <HProgressStep {...props} />
);
export const HeaderProgressStepActive: React.FunctionComponent = props => (
  <HProgressStep {...props} active={true} />
);
export const HeaderProgressStepInActive: React.FunctionComponent = props => (
  <HProgressStep {...props} active={false} />
);
export const HeaderProgressStepPrevious: React.FunctionComponent = props => (
  <>
    <HProgressStep {...props} previous={true} active={false} />
    <SvgContainerWrapper
      iconHeight='1.5em'
      iconWidth='1.5em'
      icon='arrow-right'
      iconStyle='brandText'
    />
  </>
);

HeaderProgressStep.displayName = 'HeaderProgressStep';
HeaderProgressStepActive.displayName = 'HeaderProgressActive';
HeaderProgressStepInActive.displayName = 'HeaderProgressInActive';
HeaderProgressStepPrevious.displayName = 'HeaderProgressPrevious';

const ProgressStep = Styled.div`
  font-weight: 700;

  ${media.medium`
    display: none;
  `}
`;

export const HeaderProgressStepCounter: React.FunctionComponent<{
  step: number;
}> = ({ step }) => (
  <ProgressStep>Step {step}/4</ProgressStep>
);

HeaderProgressStepCounter.displayName = 'HeaderProgressStepCounter';
